import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import InputComponent from './InputComponent';
import { FormControl, FormHelperText } from 'material-ui/Form';
import MenuItem from 'material-ui/Menu/MenuItem';
import Select from 'material-ui/Select';

import { countries } from '../../constants/ComponentTypes'

const styles = theme => ({
  root: {
    width: '100%',
    overflowY: 'auto',
  },

  row: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
  },

  half: {
    width: 'calc( 50% - 10px)',
  },

  inputRoot: {
    marginTop: '18px',
    width: '100%',
  },

  header: {
    fontSize: '13px',
    fontWeight: 'bold',
    padding: '8px 0px',
    borderBottom: '1px solid #E7E9EB',
    marginBottom: '16px',
  },

  input: {
    borderRadius: 2,
    backgroundColor: theme.palette.common.white,
    border: '1px solid #D8DBDF',
    fontSize: '15px',
    padding: '10px 12px',
    width: 'calc(100% - 24px)',
  },
});

const formProps = [
  { key: 'company', value: '会社名', placeholder: '会社名を入力' },
  { key: 'branch', value: '部署名', placeholder: '部署名を入力' },
  { key: 'name', value: '担当者名', placeholder: '担当者名を入力' },
  [{ key: 'country_id', value: '国' }, { key: 'post_code', value: '郵便番号', placeholder: '123-4567' }],
  { key: 'address', value: '住所', placeholder: '住所を入力' },
  [{ key: 'tel', value: '電話番号', placeholder: '電話番号を入力' }, { key: 'email', value: 'メールアドレス', placeholder: 'メールアドレスを入力' }],
];

class BillingAddressForm extends React.Component {
  render() {
    const { classes, values, handleChange, errors } = this.props;

    return (
      <form className={classes.root}>
        {formProps.map((prop, i) => {
          if (Array.isArray(prop)) {
            return (
              <div className={classes.row} key={i}>
                {prop.map((prop2, j) => (
                  prop2.key === 'country_id' ?
                    <div className={classes.half} key={j}>
                      <FormControl
                        className={classes.inputRoot}
                        error={errors.hasOwnProperty(prop2.key)}
                        style={{ paddingRight: '8px' }}>
                        <div className={classes.header}>{prop2.value}</div>
                        <Select
                          value={values[prop2.key]}
                          onChange={handleChange(prop2.key)}
                          classes={{ select: classes.input }}
                          disableUnderline={true}
                        >
                          {Object.values(countries).map((c, k) => (<MenuItem key={k} value={c.ISO}>{c.name}</MenuItem>))}
                        </Select>
                        <FormHelperText
                          style={{ display: errors.hasOwnProperty(prop2.key) ? 'block' : 'none' }}>
                          {errors[prop2.key] ? errors[prop2.key] : ''}
                        </FormHelperText>
                      </FormControl>
                    </div>
                    :
                    <div className={classes.half} key={j}>
                      <InputComponent
                        title={prop2.value}
                        placeholder={prop2.placeholder}
                        value={values[prop2.key]}
                        onChange={handleChange(prop2.key)}
                        error={errors[prop2.key] ? errors[prop2.key] : ''}
                      />
                    </div>
                ))}
              </div>
            )
          } else {
            return (
              <InputComponent
                title={prop.value}
                placeholder={prop.placeholder}
                key={i}
                value={values[prop.key]}
                onChange={handleChange(prop.key)}
                error={errors[prop.key] ? errors[prop.key] : ''}
              />
            )
          }
        })}
      </form>
    )
  }
}

BillingAddressForm.propTypes = {
  classes: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
};

export default withStyles(styles)(BillingAddressForm);



// WEBPACK FOOTER //
// ./src/components/common/BillingAddressForm.jsx